import type { Detected } from "./dialect.js";

/** Neural voices of the Azure Speech service (official API, free tier available): both genders, Arabic dialects and other languages. */
export interface CatalogVoice {
  id: string;
  locale: string;
  label: string;
  dialect: Exclude<Detected, null>;
  gender: "female" | "male";
  name: string;
}

export const VOICE_CATALOG: CatalogVoice[] = [
  {
    id: "ar-EG-SalmaNeural",
    locale: "ar-EG",
    label: "Egyptian",
    dialect: "ar-eg",
    gender: "female",
    name: "Salma",
  },
  {
    id: "ar-EG-ShakirNeural",
    locale: "ar-EG",
    label: "Egyptian",
    dialect: "ar-eg",
    gender: "male",
    name: "Shakir",
  },
  {
    id: "ar-SA-ZariyahNeural",
    locale: "ar-SA",
    label: "Saudi",
    dialect: "ar-sa",
    gender: "female",
    name: "Zariyah",
  },
  {
    id: "ar-SA-HamedNeural",
    locale: "ar-SA",
    label: "Saudi",
    dialect: "ar-sa",
    gender: "male",
    name: "Hamed",
  },
  {
    id: "ar-SY-AmanyNeural",
    locale: "ar-SY",
    label: "Syrian",
    dialect: "ar-levant",
    gender: "female",
    name: "Amany",
  },
  {
    id: "ar-SY-LaithNeural",
    locale: "ar-SY",
    label: "Syrian",
    dialect: "ar-levant",
    gender: "male",
    name: "Laith",
  },
  {
    id: "ar-LB-LaylaNeural",
    locale: "ar-LB",
    label: "Lebanese",
    dialect: "ar-levant",
    gender: "female",
    name: "Layla",
  },
  {
    id: "ar-LB-RamiNeural",
    locale: "ar-LB",
    label: "Lebanese",
    dialect: "ar-levant",
    gender: "male",
    name: "Rami",
  },
  {
    id: "ar-JO-SanaNeural",
    locale: "ar-JO",
    label: "Jordanian",
    dialect: "ar-levant",
    gender: "female",
    name: "Sana",
  },
  {
    id: "ar-JO-TaimNeural",
    locale: "ar-JO",
    label: "Jordanian",
    dialect: "ar-levant",
    gender: "male",
    name: "Taim",
  },
  {
    id: "ar-AE-FatimaNeural",
    locale: "ar-AE",
    label: "Emirati",
    dialect: "ar-gulf",
    gender: "female",
    name: "Fatima",
  },
  {
    id: "ar-AE-HamdanNeural",
    locale: "ar-AE",
    label: "Emirati",
    dialect: "ar-gulf",
    gender: "male",
    name: "Hamdan",
  },
  {
    id: "ar-KW-NouraNeural",
    locale: "ar-KW",
    label: "Kuwaiti",
    dialect: "ar-gulf",
    gender: "female",
    name: "Noura",
  },
  {
    id: "ar-KW-FahedNeural",
    locale: "ar-KW",
    label: "Kuwaiti",
    dialect: "ar-gulf",
    gender: "male",
    name: "Fahed",
  },
  {
    id: "ar-QA-AmalNeural",
    locale: "ar-QA",
    label: "Qatari",
    dialect: "ar-gulf",
    gender: "female",
    name: "Amal",
  },
  {
    id: "ar-QA-MoazNeural",
    locale: "ar-QA",
    label: "Qatari",
    dialect: "ar-gulf",
    gender: "male",
    name: "Moaz",
  },
  {
    id: "ar-BH-LailaNeural",
    locale: "ar-BH",
    label: "Bahraini",
    dialect: "ar-gulf",
    gender: "female",
    name: "Laila",
  },
  {
    id: "ar-BH-AliNeural",
    locale: "ar-BH",
    label: "Bahraini",
    dialect: "ar-gulf",
    gender: "male",
    name: "Ali",
  },
  {
    id: "ar-OM-AyshaNeural",
    locale: "ar-OM",
    label: "Omani",
    dialect: "ar-gulf",
    gender: "female",
    name: "Aysha",
  },
  {
    id: "ar-OM-AbdullahNeural",
    locale: "ar-OM",
    label: "Omani",
    dialect: "ar-gulf",
    gender: "male",
    name: "Abdullah",
  },
  {
    id: "ar-IQ-RanaNeural",
    locale: "ar-IQ",
    label: "Iraqi",
    dialect: "ar-gulf",
    gender: "female",
    name: "Rana",
  },
  {
    id: "ar-IQ-BasselNeural",
    locale: "ar-IQ",
    label: "Iraqi",
    dialect: "ar-gulf",
    gender: "male",
    name: "Bassel",
  },
  {
    id: "ar-MA-MounaNeural",
    locale: "ar-MA",
    label: "Moroccan",
    dialect: "ar-maghreb",
    gender: "female",
    name: "Mouna",
  },
  {
    id: "ar-MA-JamalNeural",
    locale: "ar-MA",
    label: "Moroccan",
    dialect: "ar-maghreb",
    gender: "male",
    name: "Jamal",
  },
  {
    id: "ar-TN-ReemNeural",
    locale: "ar-TN",
    label: "Tunisian",
    dialect: "ar-maghreb",
    gender: "female",
    name: "Reem",
  },
  {
    id: "ar-TN-HediNeural",
    locale: "ar-TN",
    label: "Tunisian",
    dialect: "ar-maghreb",
    gender: "male",
    name: "Hedi",
  },
  {
    id: "ar-DZ-AminaNeural",
    locale: "ar-DZ",
    label: "Algerian",
    dialect: "ar-maghreb",
    gender: "female",
    name: "Amina",
  },
  {
    id: "ar-DZ-IsmaelNeural",
    locale: "ar-DZ",
    label: "Algerian",
    dialect: "ar-maghreb",
    gender: "male",
    name: "Ismael",
  },
  {
    id: "ar-LY-ImanNeural",
    locale: "ar-LY",
    label: "Libyan",
    dialect: "ar-maghreb",
    gender: "female",
    name: "Iman",
  },
  {
    id: "ar-LY-OmarNeural",
    locale: "ar-LY",
    label: "Libyan",
    dialect: "ar-maghreb",
    gender: "male",
    name: "Omar",
  },
  {
    id: "ar-YE-MaryamNeural",
    locale: "ar-YE",
    label: "Yemeni",
    dialect: "ar-gulf",
    gender: "female",
    name: "Maryam",
  },
  {
    id: "ar-YE-SalehNeural",
    locale: "ar-YE",
    label: "Yemeni",
    dialect: "ar-gulf",
    gender: "male",
    name: "Saleh",
  },
  {
    id: "en-US-JennyNeural",
    locale: "en-US",
    label: "American English",
    dialect: "en",
    gender: "female",
    name: "Jenny",
  },
  {
    id: "en-US-GuyNeural",
    locale: "en-US",
    label: "American English",
    dialect: "en",
    gender: "male",
    name: "Guy",
  },
  {
    id: "en-GB-SoniaNeural",
    locale: "en-GB",
    label: "British English",
    dialect: "en",
    gender: "female",
    name: "Sonia",
  },
  {
    id: "en-GB-RyanNeural",
    locale: "en-GB",
    label: "British English",
    dialect: "en",
    gender: "male",
    name: "Ryan",
  },
  {
    id: "fr-FR-DeniseNeural",
    locale: "fr-FR",
    label: "French",
    dialect: "other",
    gender: "female",
    name: "Denise",
  },
  {
    id: "fr-FR-HenriNeural",
    locale: "fr-FR",
    label: "French",
    dialect: "other",
    gender: "male",
    name: "Henri",
  },
  {
    id: "es-ES-ElviraNeural",
    locale: "es-ES",
    label: "Spanish",
    dialect: "other",
    gender: "female",
    name: "Elvira",
  },
  {
    id: "es-ES-AlvaroNeural",
    locale: "es-ES",
    label: "Spanish",
    dialect: "other",
    gender: "male",
    name: "Alvaro",
  },
  {
    id: "de-DE-KatjaNeural",
    locale: "de-DE",
    label: "German",
    dialect: "other",
    gender: "female",
    name: "Katja",
  },
  {
    id: "de-DE-ConradNeural",
    locale: "de-DE",
    label: "German",
    dialect: "other",
    gender: "male",
    name: "Conrad",
  },
  {
    id: "tr-TR-EmelNeural",
    locale: "tr-TR",
    label: "Turkish",
    dialect: "other",
    gender: "female",
    name: "Emel",
  },
  {
    id: "tr-TR-AhmetNeural",
    locale: "tr-TR",
    label: "Turkish",
    dialect: "other",
    gender: "male",
    name: "Ahmet",
  },
];

export const VOICE_ID = /^[a-z]{2,3}-[A-Z]{2}-[A-Za-z]+Neural$/;

/**
 * The voice that matches the dialect of `text` (auto mode). Egyptian text → Egyptian voice of the preferred gender,
 * Syrian/Lebanese-style text → a Levantine voice, etc.; MSA and anything unknown fall back to the Egyptian voice.
 */
export function voiceFor(
  dialect: Detected,
  gender: "female" | "male" = "female",
): CatalogVoice | undefined {
  const d = dialect ?? "ar-fusha";
  const pool = VOICE_CATALOG.filter((v) => v.gender === gender);
  const want = d === "ar-fusha" || d === "other" ? "ar-eg" : d;
  return pool.find((v) => v.dialect === want) ?? pool.find((v) => v.locale === "ar-EG");
}

/**
 * The assistant's own voice for a conversation language: a woman who speaks that language
 * (Arabic → Egyptian by default, English → US, French/Spanish/German/Turkish → their own locale; anything else → English).
 */
export function voiceForLang(
  lang: string,
  gender: "female" | "male" = "female",
  arabicDialect: Detected = "ar-eg",
): CatalogVoice | undefined {
  const code = lang.toLowerCase().slice(0, 2);
  if (code === "ar") return voiceFor(arabicDialect, gender);
  const prefix: Record<string, string> = {
    en: "en-US",
    fr: "fr-FR",
    es: "es-ES",
    de: "de-DE",
    tr: "tr-TR",
  };
  const want = prefix[code] ?? "en-US";
  return VOICE_CATALOG.find((v) => v.locale === want && v.gender === gender);
}
